/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import BasePage from '../../../shared/BasePage';
import AOForm from '../../../shared/AOForm';


class ApplicantInformationItem extends BasePage {

    initalData = () => {
        const { i18n, currentSection, errorMsgs, errorList } = this.props;
        return {
            name: {
                textValue: currentSection.name,
                subtitle:{
                    title: i18n.name.title,
                    dataKey:'nameTitle'
                },
                isError: errorList.indexOf('name') !== -1,
                errorMessage: errorMsgs['name'],
                dataKey: 'name'
            },
            idType: {
                itemTitle: {text: i18n.idType.title, dataKey: "idTypeTitle"},
                defaultValue: currentSection.idType,
                selectOptions: i18n.idType.radioItems.map(key => {
                    return ({
                            'id': key.value,
                            'text': key.display,
                            'dataKey': key.questionIndicator
                        })
                }),
                questionMark: {
                    hints: i18n.idType.hints,
                    dataKey: 'idType'
                },
                dataLabel: "idType",
                isError: errorList.indexOf('idType') !== -1,
                validatedTips: errorMsgs['idType'],
                errorMessage: errorMsgs['idType'],
                dataKey: "idType"
            },
            idNo: {
                textValue: currentSection.idNo,
                subtitle: {
                    title: i18n.idNo.title,
                    dataKey:'idNoTitle'
                },
                isError: errorList.indexOf('idNo') !== -1,
                errorMessage: errorMsgs['idNo'],
                dataKey: 'idNo'
            },
            otherIdType: {
                textValue: currentSection.otherIdType,
                subtitle: {
                    title: i18n.otherIdType.title,
                    dataKey:'otherIdTypeTitle'
                },
                isError: errorList.indexOf('otherIdType') !== -1,
                errorMessage: errorMsgs['otherIdType'],
                dataKey: 'otherIdType'
            },
            privacy: {
                checkboxName: 'privacy',
                defaultValue: currentSection.privacy,
                checkboxItems: i18n.privacy.checkboxItems.map(key => {
                    return (
                        {
                            'value': key.value,
                            'display': key.display,
                            'dataKey': 'privacy'
                        }
                    )
                }),
                isError: errorList.indexOf('privacy') !== -1,
                errorMessage: errorMsgs['privacy'],
                dataKey: 'privacy',
                ariaLabel: 'privacy'
            }
        }
    }

    render () {
        const { i18n, 
                onChangeAnswerForm,
                onBlurAction,
                currentSection
            } = this.props;
        const { name, 
                idNo, 
                idType,
                otherIdType,
                privacy
            } = this.initalData();
        return (
            <div data-id={'ApplicantInformationItem-ApplicantInformationItem-page'}>
                {/*Name of Online Appliction Contact*/}
               <div className="form-item">
                    <AOForm.InputWithPrefixSuffix
                        onChangeAction={(questionRel, value) => onChangeAnswerForm(value, 'name') }
                        onBlurAction={(questionRel, value) => onBlurAction(value, 'name') }
                        content={ name }
                    />
                </div>

                {/*ID Type*/}
                <div className="form-item">
                    <AOForm.Select
                        onChangeAction={ (questionRel, value, event) => onChangeAnswerForm(value, 'idType') }
                        content={idType}
                        />
                    {idType.defaultValue === 3 && <div className="form-sub-item">
                        <AOForm.InputWithPrefixSuffix
                            onChangeAction={(questionRel, value) => onChangeAnswerForm(value, 'otherIdType') }
                            onBlurAction={(questionRel, value) => onBlurAction(value, 'otherIdType') }
                            content={ otherIdType }
                        />
                    </div>}
                </div>

                {/*ID Number*/}
                <div className="form-item">
                    <AOForm.InputWithPrefixSuffix
                        onChangeAction={ (questionRel, value) => onChangeAnswerForm(value, 'idNo') }
                        onBlurAction={(questionRel, value) => onBlurAction(value, 'idNo') }
                        content={ idNo }
                        maxLength={currentSection.idType === 1 ? 18 : 30}
                        disabled={ false }
                        prefix={ '' }
                    />
                </div>
                
                {/*HSBC Data Privacy*/}
                <div className="form-item">
                    <AOForm.ContentOnly
                        content={{
                            title:i18n.privacyTitle,
                            dataKey:'i18n.privacyTitle'
                        }}
                    />
                </div>

                <div className="form-item">
                    <ul className="privacy-content" id="privacy0-tip">
                        <li>{i18n.privacyContent1}</li>
                        <li>
                            <FormattedHTMLMessage id="checkBoxValue"
                                defaultMessage={i18n.privacyContent2}
                            />
                        </li>
                        <li>{i18n.privacyContent3}</li>
                    </ul>
                </div>

                <div className="form-item">
                    <AOForm.CheckboxforInput
                        handleCheckboxChange={(questionRel, value) => onChangeAnswerForm(value.join(''), 'privacy')}
                        content={privacy}
                    />
                </div>

            </div>
        )
    }
}

export default ApplicantInformationItem;



// WEBPACK FOOTER //
// ./src/views/ApplicantInformation/components/ApplicantInformationItem.js